import { AxiosError } from 'axios'
import { filter, includes } from 'ramda'
import { useEffect, useState } from 'react'

import { get } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'
import { Counter } from './types'

interface Context {
  counters: Counter[]
  isFetching: boolean
}

const KNOWN_COUNTER_CODES: string[] = [
  'MAX_TRAININGS' as const,
  'MAX_TRAINING_TESTS' as const,
  'MAX_DOWNLOADS' as const,
]

const filterByKnownCodes = filter<Counter>((counter) =>
  includes(counter.code, KNOWN_COUNTER_CODES)
)

export const useCountersData = (): Context => {
  const [counters, setCounters] = useState<Counter[]>([])
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    setIsFetching(true)
    get<Counter[]>(`/licensing/counters`)
      .then((data) => {
        setIsFetching(false)
        setCounters(data)
      })
      .catch((errors: AxiosError) => {
        setIsFetching(false)
        handleApiErrors(errors)
      })
  }, [])

  return {
    counters: filterByKnownCodes(counters),
    isFetching,
  }
}
